module.exports = __webpack_public_path__ + "img/zharov.svg";